var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-platformDesc" }, [
    _c("div", { staticClass: "page-platformDesc__content" }, [
      _c("div", { staticClass: "page-platformDesc__image" }, [
        _c(
          "picture",
          [
            _vm._l(_vm.platformItem.image.sourcesTypes, function(
              sourceType,
              index
            ) {
              return _c("source", {
                key: index,
                attrs: {
                  srcset: _vm.platformItem.image[sourceType],
                  type: "image/" + sourceType
                }
              })
            }),
            _c("img", {
              attrs: {
                src: _vm.platformItem.image.jpg,
                alt: _vm.platformItem.title
              }
            })
          ],
          2
        )
      ]),
      _c("div", { staticClass: "page-platformDesc__info" }, [
        _c("div", { staticClass: "rate" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("front.provider.titles.rate")))]),
          _c(
            "div",
            { staticClass: "rate__list" },
            _vm._l(5, function(index) {
              return _c("img", {
                attrs: { src: _vm.ratingImage(index), alt: "rating" }
              })
            }),
            0
          )
        ]),
        _c("div", { staticClass: "jackpots" }, [
          _c("h2", {
            domProps: {
              textContent: _vm._s(_vm.$t("front.provider.titles.jackpots"))
            }
          }),
          _c("p", { domProps: { textContent: _vm._s(_vm.platformJackpot) } })
        ]),
        _c("div", { staticClass: "desc" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("front.provider.titles.info")))]),
          _c("div", {
            staticClass: "desc__content",
            domProps: { innerHTML: _vm._s(_vm.platformItem.content) }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }